module.exports = __webpack_public_path__ + "img/back.ae1c7114.svg";